import React, { useState, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import PropTypes from 'prop-types';

import { useOnClickOutside } from '../../utils/event';

export const PeopleSelectorPullDown = ({
  valueDisplay, options, className,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef();

  useOnClickOutside(ref, () => isOpen && setIsOpen(false));

  return (
    <div className={className}>
      <input
        className='input'
        value={valueDisplay}
        onChange={() => {}}
        onClick={() => !isOpen && setIsOpen(true)}
      />
      <CSSTransition
        in={isOpen}
        unmountOnExit={true}
        timeout={300}
        classNames={{
          enter: 'enter',
          enterActive: 'enterActive',
          exit: 'exit',
          exitActive: 'exitActive',
        }}
      >
        <div ref={ref} className="peopleSelectorPullDown">
          <PeopleSelector options={options} />
        </div>
      </CSSTransition>
    </div>
  );
};

PeopleSelectorPullDown.defaultProps = {
  className: '',
};

PeopleSelectorPullDown.propTypes = {
  options: PropTypes.array.isRequired,
  valueDisplay: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export const PeopleSelector = ({ options, className }) => {
  return (
    <div className="peopleSelectorContent">
      {options.map((o) => (
        <PeopleSelectorItem
          key={o.titleHTML}
          titleHTML={o.titleHTML}
          value={o.value}
          min={o.min}
          max={o.max}
          onValueChange={o.onValueChange}
          notes={o.notes}
          titleNotes={o.titleNotes}
          borderTopDashed={o.borderTopDashed}
        />
      ))}
    </div>
  );
};

PeopleSelector.defaultProps = {
  className: '',
};

PeopleSelector.propTypes = {
  className: PropTypes.string,
  options: PropTypes.array.isRequired,
};

const PeopleSelectorItem = ({
  titleHTML, value, min, max, onValueChange, notes, titleNotes, borderTopDashed,
}) => {
  return (
    <React.Fragment>
      <div className={`peopleSelectorItem${borderTopDashed ? ' borderTopDashed' : ''}`}>
        <div dangerouslySetInnerHTML={{ __html: titleHTML }} />
        <div className="peopleSelectorItemActionsWrap">
          <span dangerouslySetInnerHTML={{ __html: titleNotes }} />
          <div className="peopleSelectorItemActions">
            <button
              className="peopleSelectorItemButton minus"
              onClick={() => onValueChange(value - 1)}
              disabled={value === min}
            />
            <div className="peopleSelectorItemValue">
              {value}
            </div>
            <button
              className="peopleSelectorItemButton plus"
              onClick={() => onValueChange(value + 1)}
              disabled={value === max}
            />
          </div>
        </div>
      </div>
      {notes !== undefined && notes !== '' && (
        <div 
          className="peopleSelectorItemNotes" 
          dangerouslySetInnerHTML={{ __html: notes }}
        />
      )}
    </React.Fragment>
  );
};

PeopleSelectorItem.propTypes = {
  titleHTML: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  onValueChange: PropTypes.func.isRequired,
  notes: PropTypes.string,
  titleNotes: PropTypes.string,
  borderTopDashed: PropTypes.bool,
};

export const createPeopleSelectorOption = (
  titleHTML, value, min, max, onValueChange, notes = '', titleNotes = '', borderTopDashed = false,
) => ({
  titleHTML, value, min, max, onValueChange, notes, titleNotes, borderTopDashed,
});